import type { ItemRenderer } from "./types";

export const renderModuleHolder: ItemRenderer = ({ svg, bboxPx }) => {
    const color = "#a64022";

    const barStroke = 0.45;
    const maxBarH = Math.max(0, bboxPx.h - barStroke);
    const rawBarH = Math.max(4, Math.min(10, bboxPx.h * 0.28));
    const barH = Math.min(rawBarH, maxBarH);
    const barX = bboxPx.x + barStroke / 2;
    const barW = Math.max(0, bboxPx.w - barStroke);
    const barY = bboxPx.y + bboxPx.h - barStroke / 2 - barH;

    svg.rect(barW, barH).move(barX, barY).fill("#fff").stroke({ width: barStroke, color });

    const holderStroke = 0.45;
    const y1 = bboxPx.y;
    const y2 = bboxPx.y + bboxPx.h;
    const xLeft = bboxPx.x + holderStroke / 2;
    const xRight = bboxPx.x + bboxPx.w - holderStroke / 2;

    svg.line(xLeft, y1, xLeft, y2).stroke({ width: holderStroke, color, linecap: "butt" });
    svg.line(xRight, y1, xRight, y2).stroke({ width: holderStroke, color, linecap: "butt" });

    const cy = barY + barH / 2;

    const strokePx = 0.6;
    const rBase = Math.max(1.0, Math.min(4, barH * 0.18));
    const rMaxByBar = Math.max(0, (barH - barStroke) / 2);
    const r = Math.min(rBase, rMaxByBar);
    const d = r * 2;

    const outerD = d;
    const emptyD = Math.max(0.8, outerD - strokePx);

    const drawEmpty = (cx: number) => svg.circle(emptyD).center(cx, cy).fill("none").stroke({ width: strokePx, color });
    const drawFilled = (cx: number) => svg.circle(outerD).center(cx, cy).fill(color);

    const edgeGap = Math.max(6, r * 1.5);

    const safeLeftByStands = bboxPx.x + holderStroke + edgeGap + r;
    const safeRightByStands = bboxPx.x + bboxPx.w - holderStroke - edgeGap - r;
    const safeLeftByBar = barX + barStroke / 2 + r;
    const safeRightByBar = barX + barW - barStroke / 2 - r;

    const safeLeft = Math.max(safeLeftByStands, safeLeftByBar);
    const safeRight = Math.min(safeRightByStands, safeRightByBar);
    const safeW = Math.max(0, safeRight - safeLeft);
    if (safeW <= 0) return;

    const xL1 = safeLeft;
    const xR1 = safeRight;
    drawEmpty(xL1);
    drawEmpty(xR1);

    const minGap = Math.max(3, 0.6 * r);
    const step = d + minGap;
    const xL2 = xL1 + step;
    const xR2 = xR1 - step;

    if (xL2 + r >= xR2 - r) return;

    drawFilled(xL2);
    drawFilled(xR2);

    const spanStart = xL2;
    const spanEnd = xR2;
    const spanW = spanEnd - spanStart;

    const N = Math.max(0, Math.floor(spanW / (d + minGap)) - 1);
    if (N > 0) {
        const evenStep = spanW / (N + 1);
        for (let i = 1; i <= N; i++) {
            drawEmpty(spanStart + i * evenStep);
        }
    }
};
